<template>
    <div>

    </div>
</template>

<script>
  export default {
    name: 'CampaignConstraint'
  };
</script>

<style lang="scss" scoped>

</style>
